import React, { useState } from 'react';
import { IntlProvider } from 'react-intl';
import english from '../../languages/english.json';
import portuguese from '../../languages/portuguese.json';
import deutsch from '../../languages/german.json';
import french from '../../languages/french.json';
import italian from '../../languages/italian.json';
import slovak from '../../languages/slovak.json';
import czech from '../../languages/czech.json';
import croatia from '../../languages/croatia.json';
import slovenia from '../../languages/slovenia.json';

export const Context = React.createContext();

const LANGUAGE_STORAGE_KEY = 'app_language';
const BACKUP_STORAGE_KEY = '@Squre:language';

const languages = {
  en: english,
  pt: portuguese,
  de: deutsch,
  fr: french,
  it: italian,
  cs: czech,
  sk: slovak,
  sl: slovenia,
  hr: croatia,
};

// 1. Detect saved language; default to English ('en') if not selected
const getInitialLocale = () => {
  try {
    const saved =
      localStorage.getItem(LANGUAGE_STORAGE_KEY) ||
      localStorage.getItem(BACKUP_STORAGE_KEY);
    if (saved && languages[saved]) {
      return saved;
    }
  } catch (err) {}

  // Default language is English if no language has been selected yet
  return 'en';
};

const Wrapper = (props) => {
  const [locale, setLocale] = useState(getInitialLocale);
  const [messages, setMessages] = useState(() => languages[locale] || english);

  function selectLanguage(e) {
    const newLocale = typeof e === 'string' ? e : e?.target?.value;
    if (newLocale && languages[newLocale]) {
      setLocale(newLocale);
      setMessages(languages[newLocale]);
      try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, newLocale);
        localStorage.setItem(BACKUP_STORAGE_KEY, newLocale);
      } catch (err) {
        console.error('Failed to save language to localStorage:', err);
      }
    }
  }

  return (
    <Context.Provider value={{ locale, selectLanguage }}>
      <IntlProvider messages={messages} locale={locale}>
        {props.children}
      </IntlProvider>
    </Context.Provider>
  );
};

export default Wrapper;
